import {UIComponent} from "@/engine/UI/UIComponent.js";
import {UIProperties} from "@/engine/UI/UIProperties.js";
import {UITemplates} from "@/engine/UITemplates.js";
import {locationFromMapState, locationUri} from "@/engine/helpers/HLocationURI.js";
import {mapContext} from "@/context/global.js";

export class UICShareMapIFrame extends UIComponent {
    constructor(options) {
        super(options, null);
        this.id = 'shareMapIFrame'
        this.title = ''
        this.mainActionName = ''
        this.cancelActionName = 'CLOSE'
        this.iframeOptions = {
            moving: true,
            zooming: true,
            width: 1000,
            height: 500
        }
        this.uriOptions = {
            'em': 'moving',
            'ez': 'zooming'
        }
        // defines the style of area preview rectangle
        this.rectanglePreviewStyle = {
            stroke: true,
            weight: 1,
            opacity: 1,
            color: "gray",
            fillColor: "yellow",
            fillOpacity: 0.1
        }
        this.rectanglePreview = null
        this.map = mapContext.map
        this.UIP = new UIProperties(
            UITemplates.getContent("iframe-to-share", {}),
        {
                propertiesFactory: async function (prop) {
                    for (let o in this.iframeOptions) {
                        prop[o] = this.iframeOptions[o]
                    }
                    prop.text = this._iframeHTML()
                }.bind(this),
                togglersCallbacks: {
                    "moving" : function (val, fail) {
                        this.iframeOptions.moving = val;
                        this._updateUIC();
                    }.bind(this),
                    "zooming": function (val, fail) {
                        this.iframeOptions.zooming = val;
                        this._updateUIC();
                    }.bind(this),
                    "width": function (val, fail) {
                        this.iframeOptions.width = val * 1;
                        this._updatePreviewRect()
                        this._updateUIC()
                    }.bind(this),
                    "height": function (val, fail) {
                        this.iframeOptions.height = val * 1;
                        this._updateUIC()
                        this._updatePreviewRect()
                    }.bind(this)
                }
            },
        )
        this.view = this.UIP
    }

    open(container, parent, data) {
        super.open(container, parent, data)
        this.map.setMaxBounds(this.workspace.bounds);
        this._updatePreviewRect()
        this.map.on('moveend', this._mapUpdatedEvent, this);
        this.map.on('zoomend', this._mapUpdatedEvent, this);
    }

    close() {
        this._finish()
        super.close()
    }

    onCancelAction() {
        this._finish()
        return true
    }

    _finish() {
        this.rectanglePreview.remove()
        this.rectanglePreview = null
        this.map.setMaxBounds(null);
        this.map.off('moveend', this._mapUpdatedEvent, this)
        this.map.off('zoomend', this._mapUpdatedEvent, this)
    }

    _mapUpdatedEvent() {
        this._updatePreviewRect()
        this._updateUIC()
    }
    _updateUIC() {
        this.UIP.setItemValue('text', this._iframeHTML())
        let e = this.UIP.getItem('text')
        // blink field on changes
        e.style.backgroundColor = '#ffffcc';
        setTimeout(() => {
            e.style.backgroundColor = '';
        }, 500);
    }

    _updatePreviewRect() {
        let center = this.map.project(this.map.getCenter(), this.map.getZoom())
        let nw = L.point(center.x - this.iframeOptions.width / 2, center.y - this.iframeOptions.height / 2)
        let se = L.point(nw.x + this.iframeOptions.width, nw.y + this.iframeOptions.height)
        let bounds = L.latLngBounds(
            this.map.unproject(nw, this.map.getZoom()),
            this.map.unproject(se, this.map.getZoom())
        )
        if (! this.rectanglePreview) {
            this.rectanglePreview = L.rectangle(bounds, Object.assign({}, this.rectanglePreviewStyle))
            this.rectanglePreview.addTo(this.map)
        } else {
            this.rectanglePreview.setBounds(bounds)
        }

        // update map max bounds
        bounds = this.workspace.bounds
        if (bounds) {
            nw = this.map.project(bounds.getNorthWest(), this.map.getZoom())
            se = this.map.project(bounds.getSouthEast(), this.map.getZoom());
            // extend bound to 25%
            nw.x -= this.iframeOptions.width / 4
            nw.y -= this.iframeOptions.height / 4
            se.x += this.iframeOptions.width / 4
            se.y += this.iframeOptions.height / 4
            bounds = L.latLngBounds(
                this.map.unproject(nw, this.map.getZoom()),
                this.map.unproject(se, this.map.getZoom())
            )
            this.map.setMaxBounds(bounds);
        }
    }

    _iframeHTML() {
        let options = []
        for ( let o in this.uriOptions ) {
            if (this.uriOptions[o] in this.iframeOptions) {
                let v = this.iframeOptions[this.uriOptions[o]]
                options.push(o + '=' + ( v ? 1 : 0))
            }
        }
        options.push("eo=1")
        options.push(locationUri(locationFromMapState(this.map)))
        return `<iframe src="${this.link}?${options.join('&')}" style="border:none" width="${this.iframeOptions.width}px" height="${this.iframeOptions.height}px" title="${this.workspace.name}"></iframe>`
    }
}
